export type WaitingRoomAutoSyncTargetType = 'sign' | 'line_item' | 'kop_item'

export interface WaitingRoomAutoSyncTarget {
  target_type: WaitingRoomAutoSyncTargetType
  target_id: string
  project_id: string | null
}

export interface WaitingRoomAutoSyncResult {
  status: 'completed'
  accepted_count: number
  accepted_waiting_room_file_ids: string[]
  uploaded_count: number
  managed_upload_count: number
  managed_link_count: number
  advanced_count?: number
  advanced_targets?: WaitingRoomAutoSyncTarget[]
  affected_targets: WaitingRoomAutoSyncTarget[]
}

const REFRESH_EVENT = 'look:waiting-room-auto-sync-refresh'

const dispatch = <T>(eventName: string, detail: T) => {
  window.dispatchEvent(new CustomEvent<T>(eventName, { detail }))
}

const subscribe = <T>(eventName: string, callback: (detail: T) => void) => {
  const handler = (event: Event) => callback((event as CustomEvent<T>).detail)
  window.addEventListener(eventName, handler)

  return () => window.removeEventListener(eventName, handler)
}

export const refreshWaitingRoomAutoSyncedTargets = (result: WaitingRoomAutoSyncResult) => {
  dispatch(REFRESH_EVENT, result)
}

export const onWaitingRoomAutoSyncRefresh = (
  callback: (result: WaitingRoomAutoSyncResult) => void,
) => {
  return subscribe(REFRESH_EVENT, callback)
}
